export function isAxiosError(error) {
    return error === null || error === void 0 ? void 0 : error.isAxiosError;
}
/**
 * Detects network/CORS failures. A CORS rejection is indistinguishable from a
 * generic network failure in the browser — both reject as an AxiosError with no
 * `response` and `code === 'ERR_NETWORK'` (message 'Network Error'). Request
 * timeouts (`ECONNABORTED`) are intentionally NOT treated as CORS errors.
 */
export function isNetworkOrCorsError(error) {
    if (!isAxiosError(error)) {
        return false;
    }
    return (error.response === undefined &&
        (error.code === 'ERR_NETWORK' || error.message === 'Network Error'));
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function onApiError(url, params, e) {
    var _a;
    // TODO: Remove this line when the API is ready.
    if (url === '/addons')
        return e;
    if (isAxiosError(e)) {
        const statusCode = Number((_a = e.response) === null || _a === void 0 ? void 0 : _a.status);
        if (statusCode >= 400 && statusCode < 500) {
            // need to handle errors here.
            const { message: _message } = e;
            //notificationError(message);
            return e;
        }
    }
    //notificationError("Internal server error");
    return e;
}
